import Header from './Header';

const heroItems = [
  'Family Tree Maker Download & Copies',
  'Setup & Installation Guides',
  'Upgrade & Migration Assistance',
  'Backup & Restore Guides',
  'Sync Error & Troubleshooting',
  'No Internet Fix Guide',
  'FamilySearch Integration Help',
  'Media & Document Management',
  'TreeVault Cloud Support',
];

export default function Hero() {
  return (
    <section className="w-full flex flex-col">
      <Header />

      <div className="flex flex-col md:flex-row flex-grow min-h-[560px] md:min-h-[640px]">
        <div className="w-full md:w-1/2 bg-[#15803d] flex flex-col justify-center px-5 sm:px-8 md:px-16 py-10 md:py-14 order-2 md:order-1">
          <div className="max-w-xl mx-auto md:mx-0 w-full">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight tracking-tight">
              Family Tree Maker
            </h1>
            <p className="text-sm sm:text-base md:text-lg leading-relaxed text-white/90 mb-8">
              More than genealogy software—Family Tree Maker is a trusted home for your family history.
              We combine powerful tools with dedicated support so you can preserve and share your heritage
              with confidence.
            </p>

            <ul className="grid gap-2 text-sm md:text-base text-white/95">
              {heroItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="text-[#86efac] mt-0.5 font-semibold shrink-0">✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="w-full md:w-1/2 relative min-h-[240px] sm:min-h-[300px] md:min-h-full order-1 md:order-2">
          <img
            src="/hero_bg.jpg"
            alt="Family history and genealogy"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-transparent to-transparent md:from-transparent" />
        </div>
      </div>
    </section>
  );
}
